import CMS from "netlify-cms-app";
import uploadcare from "netlify-cms-media-library-uploadcare";
import cloudinary from "netlify-cms-media-library-cloudinary";

import AboutPagePreview from "./preview-templates/AboutPagePreview";
import NewsPostPreview from "./preview-templates/NewsPostPreview";
import IndexPagePreview from "./preview-templates/IndexPagePreview";
import ReferralPagePreview from "./preview-templates/ReferralPagePreview";
import SensoryRoomPagePreview from "./preview-templates/SensoryRoomPagePreview";
import GalleryPagePreview from "./preview-templates/GalleryPagePreview";
import SupportUsPagePreview from "./preview-templates/SupportUsPagePreview";
import FinancialDonationPagePreview from "./preview-templates/FinancialDonationPagePreview";
import PhysicalDonationPagePreview from "./preview-templates/PhysicalDonationPagePreview";
import FundraisingPagePreview from "./preview-templates/FundraisingPagePreview";
import VolunteeringPagePreview from "./preview-templates/VolunteeringPagePreview";
import BusinessesPagePreview from "./preview-templates/BusinessesPagePreview";
import SchoolsPagePreview from "./preview-templates/SchoolsPagePreview";
// import SuccessStoriesPostPreview from './preview-templates/SuccessStoriesPostPreview'
import ContactUsThanksPagePreview from "./preview-templates/ContactUsThanksPagePreview";

CMS.registerMediaLibrary(uploadcare);
CMS.registerMediaLibrary(cloudinary);

CMS.registerPreviewTemplate("index", IndexPagePreview);
CMS.registerPreviewTemplate("about", AboutPagePreview);
CMS.registerPreviewTemplate("referral", ReferralPagePreview);
CMS.registerPreviewTemplate("sensory-room", SensoryRoomPagePreview);
CMS.registerPreviewTemplate("news", NewsPostPreview);
CMS.registerPreviewTemplate("gallery", GalleryPagePreview);
CMS.registerPreviewTemplate("supportus", SupportUsPagePreview);
CMS.registerPreviewTemplate("financial-donation", FinancialDonationPagePreview);
CMS.registerPreviewTemplate("physical-donation", PhysicalDonationPagePreview);
CMS.registerPreviewTemplate("fundraising", FundraisingPagePreview);
CMS.registerPreviewTemplate("volunteering", VolunteeringPagePreview);
CMS.registerPreviewTemplate("businesses", BusinessesPagePreview);
CMS.registerPreviewTemplate("schools", SchoolsPagePreview);
// CMS.registerPreviewTemplate('success-stories', SuccessStoriesPostPreview)
CMS.registerPreviewTemplate("contact-us-thanks", ContactUsThanksPagePreview);
